import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const NumberedListSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <rect x="11" y="10" width="10" height="1" fill="#BCBEC2" />
      <rect x="11" y="12" width="10" height="1" fill="#BCBEC2" />
      <rect x="11" y="14" width="8" height="1" fill="#BCBEC2" />
      <path
        d="M4.239 15H5.373V9.995H4.379L3.224 10.814V11.78L4.239 11.115V15ZM6.93411 15.063C7.29111 15.063 7.56411 14.79 7.56411 14.447C7.56411 14.111 7.29111 13.838 6.93411 13.838C6.58411 13.838 6.31111 14.111 6.31111 14.447C6.31111 14.79 6.58411 15.063 6.93411 15.063Z"
        fill="#55585E"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
    </svg>
  </span>
);

export default NumberedListSVG;
